import React, { useEffect } from "react";
import { faBookOpen, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Button, Col, ListGroupItem, Row, Stack } from "react-bootstrap";
import ReactMarkdown from "react-markdown";

function StickyMenu() {
  const [open, setOpen] = useState(false);
  const [showReleaseNotes, setShowReleaseNotes] = useState(false);
  const [releaseNotes, setReleaseNotes] = useState<string | null>(null);
  const menuRef = React.useRef<HTMLDivElement>(null);

  const startPendoGuide = () => {
    if (window.pendo) {
      window.pendo.showGuideById("cHxrbegS7-r4uOCAsJk4MQRoCqU");
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpen(false);
        setShowReleaseNotes(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuRef]);

  const loadReleaseNotes = async () => {
    if (releaseNotes) return;
    const res = await fetch("/release.md");
    const text = await res.text();
    setReleaseNotes(text);
  };

  return (
    <div
      ref={menuRef}
      className={`fab-wrapper app-primary-alt-color ${open && "open"} ${showReleaseNotes && "release"}`}
      onClick={() => {
        setOpen(!open);
        setShowReleaseNotes(false);
      }}
    >
      <Button variant="transparent" className={`text-white w-100 ${!open && "fab-button"}`}>
        <Row>
          <Col xs={open ? 10 : 0} className="text-start">
            {open && <FontAwesomeIcon icon={faBookOpen} className="me-2" />}
            {open && "Resources"}
          </Col>
          <Col xs={open ? 2 : 12} className={open ? "text-end" : "text-center"}>
            <FontAwesomeIcon icon={open ? faTimes : faBookOpen} className={open ? "" : ""} />
          </Col>
        </Row>
      </Button>

      <Stack direction="vertical" className="fab-menu p-0 mx-2 mb-2 rounded-3" gap={1} onClick={(e) => e.stopPropagation()}>
        <ListGroupItem
          variant="light"
          className="py-2 ps-2 cursor-pointer"
          onClick={async () => {
            await loadReleaseNotes();
            setShowReleaseNotes((prev) => !prev);
          }}
        >
          {`Release Notes ${localStorage.getItem("appVersion")}`}
        </ListGroupItem>
        <div className={`release-notes app-secondary-color-inverse ${showReleaseNotes && "open"}`}>
          {releaseNotes && <ReactMarkdown children={releaseNotes} />}
        </div>
        <ListGroupItem
          variant="light"
          className="py-2 ps-2 cursor-none"
          onClick={async () => {
            startPendoGuide();
          }}
        >
          Onboarding (Coming Soon)
        </ListGroupItem>
      </Stack>
    </div>
  );
}
export default StickyMenu;
